module.exports = __webpack_public_path__ + "img/banjo-kazooie.20f6c47a.png";